import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/NavBar/NavBar";
import Chatbot from "../../components/ChatBot/ChatBot";
import Testimonials from "../../components/Testimonials/Testimonials";
import ContactEmail from "../../components/ContactEmail/ContactEmail";
import Footer from "../../components/Footer/Footer";
import Scroll from "./Scroll";
import TypewriterText from "../../hooks/useType";
import { FiArrowUp, FiPhone } from "react-icons/fi";
import Partners from "./Partners";
import { MessageCircle, X } from "lucide-react";

export default function Home() {
  const [play, setPlay] = useState(false);
  const [fade, setFade] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isAtContactSection, setIsAtContactSection] = useState(false);
  const [modal, setModal] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  useEffect(() => {
    const hideModal = localStorage.getItem("hideWelcomeModal");
    if (hideModal !== "true") {
      setModal(true);
    }
  }, []);

  const closeModal = () => {
    if (dontShowAgain) {
      localStorage.setItem("hideWelcomeModal", "true");
    }
    setModal(false);
  };

  const toggleCheckbox = () => {
    setDontShowAgain((prev) => !prev);
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    if (isAtContactSection) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      contactEmailRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const handleScroll = () => {
    if (contactEmailRef.current) {
      const contactPosition =
        contactEmailRef.current.getBoundingClientRect().top + window.scrollY;
      const currentPosition = window.scrollY + window.innerHeight;

      if (currentPosition >= contactPosition) {
        setIsAtContactSection(true);
      } else {
        setIsAtContactSection(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navigate = useNavigate();
  const contactEmailRef = useRef(null);

  const openModal = () => {
    setIsModal(true);
  };

  const handleVideoEnd = () => {
    setFade(true);
    setTimeout(() => {
      setPlay((prev) => !prev);
      setFade(false);
    }, 700);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    setTimeout(() => {
      setIsModal(true);
    }, 1500);
  }, []);
  return (
    <div className="">
      <div className="fixed right-7 bottom-[19%] sm:bottom-[16%] sm:right-6 z-50">
        <button
          onClick={handleButtonClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className={`flex items-center justify-center h-14 bg-green-600 rounded-full shadow-md transition-all duration-200 ${
            isHovered ? "w-56 px-4" : "w-14"
          }`}>
          {isAtContactSection ? (
            <FiArrowUp className="text-xl text-white" />
          ) : (
            <FiPhone className="text-xl text-white" />
          )}
          {isHovered && (
            <span className="ml-4 text-lg font-medium text-white transition-opacity duration-200">
              {isAtContactSection ? "Scroll to Top" : "Contact Us"}
            </span>
          )}
        </button>
      </div>

      <Navbar />
      <section className="relative z-10 flex items-center w-full px-4 py-6 text-gray-900 bg-gradient-to-r from-green-700 via-green-400 to-green-700 sm:py-12">
        <div
          data-aos="flip-down"
          className="flex flex-col items-center justify-around w-full sm:flex-row">
          <div className="relative w-full max-w-lg text-center sm:w-1/2 sm:text-left">
            <h1 className="mb-4 text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl">
              Transforming Accounting with{" "}
              <span className="text-yellow-400 underline decoration-wavy">
                AI Precision
              </span>{" "}
              & Human Expertise
            </h1>
            <p className="mb-6 text-sm font-light text-white sm:text-md lg:text-lg">
              Intelligent solutions tailored for accountants, entrepreneurs, and
              organizations worldwide—from bustling cities to remote corners.
            </p>
            <a
              href="#getstarted"
              className="inline-block px-6 py-3 mb-8 text-sm font-bold text-black transition duration-300 ease-in-out transform bg-yellow-500 rounded-full shadow-lg sm:mb-0 sm:text-md lg:text-lg hover:scale-105"
              onClick={(e) => {
                navigate("/signup");
                window.scrollTo(0, 0);
              }}>
              Get Started →
            </a>
          </div>
          <Chatbot openModal={openModal} />
        </div>
      </section>

      <section className="bg-gradient-to-r from-green-700 via-green-400 to-green-700 py-8 sm:py-16 px-2 relative min-h-auto sm:min-h-[75vh]">
        <div className="container flex flex-col items-center justify-between mx-auto space-y-8 sm:flex-row sm:space-y-0 sm:space-x-4">
          <div
            className="flex-1 text-center sm:pr-8 h-[40vh]"
            data-aos="fade-up">
            <h2 className="flex items-center justify-center h-full text-2xl font-extrabold leading-tight text-white break-words sm:text-3xl md:text-4xl">
              <TypewriterText />{" "}
            </h2>
          </div>

          <div
            className="flex justify-center flex-1 max-w-xs sm:justify-start sm:p-1 sm:max-w-md"
            data-aos="fade-down">
            <img
              src="https://bethaibucket.s3.us-east-1.amazonaws.com/images/botmascot.gif"
              alt="Mascot for Accounting Chatbot Philippines Artifical Intelligence"
              className="object-contain w-auto h-full max-h-full"
            />
          </div>
        </div>
      </section>

      <div className="px-4 py-16 bg-gradient-to-r from-green-700 via-green-400 to-green-700">
        <div className="flex flex-col items-center justify-center mx-auto space-y-6">
          <div className="w-full text-center">
            <p className="text-2xl font-bold text-white sm:text-3xl md:text-4xl">
              Witness the Future with{" "}
              <span className="text-yellow-400">B.E.T.H.</span> in Action
            </p>
          </div>
          <div className="w-full p-2 overflow-hidden sm:w-4/5">
            <video
              className={`relative z-10 w-full h-auto max-h-96 rounded-lg object-contain transition-opacity duration-700 ${
                fade ? "opacity-0" : "opacity-100"
              }`}
              src={
                play
                  ? "https://bethaibucket.s3.us-east-1.amazonaws.com/videos/landingvid2.mp4"
                  : "https://bethaibucket.s3.us-east-1.amazonaws.com/videos/BETH_Video_09042024.mp4"
              }
              muted
              controls
              autoPlay={false}
              loop={false}
              onEnded={handleVideoEnd}
            />
          </div>
        </div>
      </div>

      <div className="px-10 mt-10">
        <section className="flex flex-col items-center py-12 text-center lg:flex-row-reverse md:text-left lg:py-16">
          <div className="flex justify-center w-full px-4 mb-6 lg:w-2/3 lg:mb-0">
            <div className="relative w-full max-w-sm overflow-hidden rounded-lg shadow-lg sm:max-w-md lg:max-w-lg">
              <img
                src="pic5.jpeg"
                alt="About B.E.T.H. AI Chatbot Philippines"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
          <div className="w-full px-4 lg:w-1/2 lg:px-8">
            <h2 className="mb-6 text-3xl font-extrabold text-black lg:text-4xl">
              About <span className="text-green-500">B.E.T.H.</span>
            </h2>
            <p className="mb-6 text-lg leading-relaxed text-gray-700">
              B.E.T.H. is the ultimate AI platform designed for professionals in
              auditing, tax, and accounting. Instantly get accurate answers to
              your complex financial and compliance questions.
            </p>
            <p className="mb-6 text-lg leading-relaxed text-gray-700">
              Join our community and lead the future of the accounting industry.
              B.E.T.H. helps you leverage AI to stay ahead and be the expert in
              your field.
            </p>
            <div className="flex justify-center lg:justify-start">
              <Link
                to="/signup"
                onClick={() => window.scrollTo(0, 0)}
                className="inline-block px-6 py-3 font-semibold text-white transition-all duration-300 bg-green-500 rounded-full shadow-md hover:bg-green-600">
                Register Now
              </Link>
            </div>
          </div>
        </section>

        <div className="flex flex-col items-center justify-between w-full mt-8 sm:flex-row">
          <Scroll />
          <div className="flex flex-col my-8 text-center sm:text-left sm:my-0">
            <p className="max-w-lg text-2xl font-bold text-black sm:text-3xl">
              Where accuracy meets authoritative knowledge.
            </p>
            <p className="max-w-lg mt-4 text-gray-700 text-md">
              Learn more about our reliable sources{" "}
              <Link
                to="/sources"
                className="text-green-500 underline">
                here
              </Link>
              .
            </p>
          </div>
        </div>

        <section className="relative z-10 py-16 mt-12 bg-white rounded-lg shadow-lg">
          <div className="container mx-auto text-center">
            <div className="mb-12 text-center">
              <h2 className="text-4xl font-extrabold text-black">
                Our <span className="text-green-500">Features</span>
              </h2>
              <p className="max-w-2xl mx-auto mt-4 text-lg text-gray-600">
                Discover the powerful features that make our application stand
                out.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-12">
              <div className="flex flex-col items-center p-6 transition-all duration-300 rounded-lg shadow-md bg-gray-50 hover:shadow-xl">
                <img
                  src="fast.svg"
                  alt="Instant Research of Accounting Chatbot Philippines"
                  className="w-16 h-16 mb-4"
                />
                <h3 className="mb-2 text-xl font-semibold text-black">
                  Instant Research
                </h3>
                <p className="text-center text-gray-500 text-md">
                  Ask for solutions for Tax, Accounting, Audit, and Licensing in
                  seconds.
                </p>
              </div>

              <div className="flex flex-col items-center p-6 transition-all duration-300 rounded-lg shadow-md bg-gray-50 hover:shadow-xl">
                <img
                  src="search.svg"
                  alt="Quick Email Response of BETH AI"
                  className="w-16 h-16 mb-4"
                />
                <h3 className="mb-2 text-xl font-semibold text-black">
                  Quick Email Response
                </h3>
                <p className="text-center text-gray-500 text-md">
                  Give B.E.T.H. a brief prompt, and it’ll craft a professional
                  email for proposals, pitches, or client responses.
                </p>
              </div>
            </div>

            <div className="flex justify-center mt-12">
              <Link
                to="/features"
                onClick={scrollToTop}
                className="flex items-center justify-center w-full h-12 max-w-xs text-lg text-white transition-all duration-300 bg-green-500 rounded-full shadow-md hover:bg-green-600">
                Learn More
              </Link>
            </div>
          </div>
        </section>
        <Partners />
        <Testimonials />
        <ContactEmail ref={contactEmailRef} />
      </div>
      <Footer />
      {modal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-[640px] flex flex-col gap-8 relative items-center py-10 text-center rounded-md shadow-sm shadow-black/30 bg-customSlate-300 ">
            <button
              className="absolute top-0 right-0 p-2 rounded-full text-customText-900 -translate-x-1/3 translate-y-1/3 hover:bg-red-500 hover:text-customText-100"
              onClick={closeModal}>
              <X className="size-5" />
            </button>
            <div>
              <h2 className="text-2xl font-bold text-customText-900">
                Try our new feature on B.E.T.H. AI
              </h2>
              <h2 className="text-2xl font-bold text-customGreen-700">
                Invoicing Checker Bot
              </h2>
            </div>
            <div className="flex flex-col items-center w-full gap-4">
              <Link to="/features/invoicing-checker">
                <button className="flex px-4 py-1.5 gap-2.5 w-fit items-center font-semibold rounded-full text-customText-100 bg-customGreen-500 hover:bg-customGreen-700">
                  <MessageCircle className="size-5" />
                  <span>Invoicing Checker Bot</span>
                </button>
              </Link>
              <span className="px-12 text-sm text-text-900">
                Invoicing Bot helps businesses, accountants, and finance teams
                ensure that every invoices complies with BIR regulations. The
                bot instantly reviews, validates, and highlights compliance
                issues and provides a detailed report of any issues found.
              </span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <input
                type="checkbox"
                id="dontShow"
                checked={dontShowAgain}
                onChange={toggleCheckbox}
                className="w-4 h-4 rounded text-customGreen-700 focus:ring-customGreen-500"
              />
              <label
                htmlFor="dontShow"
                className="text-sm cursor-pointer text-customText-800">
                Don’t show this again.
              </label>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
